import MoVeInWelcome from './MoVeInWelcome';
export default MoVeInWelcome;
